import React, { Component } from 'react';
import { Modal } from "react-bootstrap"
import { withTranslation } from 'react-i18next';

class EducationListModal extends Component {

    constructor(props) {
        super(props)
        this.state = {
            educations:[],
            transPage: "modals.education_list."
        }

        this.getEducation = this.getEducation.bind(this)
        this.onOpenModal = this.onOpenModal.bind(this)
    }

    onOpenModal() {
        this.getEducation()
    }

    getEducation() {
        this.setState({
            educations:this.props.educations
        })
    }

    render() {
        const {t} = this.props;
        const Education = this.state.educations.map(item => {
            return (<tr>
                <td>{item.title}</td>
                <td>{item.level}</td>
                <td>{item.school}</td>
                <td>{item.description}</td>
                <td>{ item.date_start } - { item.date_finish}</td>
            </tr>)
        })

        return (
            <Modal size="lg" show={this.props.show} onHide={this.props.onHide} onShow={this.onOpenModal}>
                <Modal.Header closeButton className="bg-primary">
                    {t('education')}
                </Modal.Header>
                <Modal.Body>
                    <div className="row">

                        

                       <table className="table table-bordered">
                           <thead>
                               <th> {t('title')} </th>
                               <th> {t('level')} </th>
                               <th> {t('school')} </th>
                               <th> {t('description')} </th>
                               <th> {t('from')} </th>
                           </thead>
                           <tbody>
                               { Education }
                           </tbody>
                       </table>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-primary" onClick={() => { this.props.onHide() }}> {t('ok')} </button>
                   
                </Modal.Footer>
            </Modal>
        );
    }
}

export default withTranslation()(EducationListModal);